/**
 * The STARS marks Astra supplied on 2026-10-05 (design/brand/astra-supplied-2026-10-05/),
 * trimmed by design/brand/make-web-icons.py. White on transparent: they sit on navy,
 * the starfield or a pass. `wordmark` is the "STARS powered by Astra" lockup (sign-in,
 * payment, error page); `mark` is the star alone (the rail, 36px). Vector files swap in
 * here later, one line per variant.
 */
import React from "react";
import wordmark from "../../assets/images/brand/stars-wordmark-white.png";
import mark from "../../assets/images/brand/stars-mark-white.png";
import { cn } from "./cn";

const SRC = { wordmark, mark };

export function Logo({
  variant = "wordmark",
  alt = "STARS",
  className,
  ...props
}) {
  return (
    <img
      src={SRC[variant]}
      alt={alt}
      className={cn("tw-block tw-h-auto", className)}
      {...props}
    />
  );
}
